import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, Fact, LoggerService, MoneyAccount, MoneyService, ValueType } from '@rollit/shared/data';
import * as moment_ from 'moment';
import { randomString } from '@rollit/shared/utils';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

const moment = moment_;

@Injectable()
export class InvestmentsService {
  log: any;
  sessionId: string;

  constructor(
    private moneyService: MoneyService,
    private dialogService: DialogService,
    private router: Router,
    private logger: LoggerService,
  ) {
    this.log = this.logger.info('invetmentsService');
  }

  /**
   * Fetch investment accounts.
   */
  getAccounts(): Observable<MoneyAccount[]> {
    return this.moneyService.getAccounts({ type: 'investment' });
  }

  /**
   * Fetch projections for investment/business account.
   * 
   * @param accountId 
   */
  getProjections(accountId: number, numPeriods: number): Observable<any> {
    const from = moment().startOf('month');
    return this.moneyService.getAccountProjections(accountId, from, null, numPeriods);
  }

  /**
   * start a dialog to create a new asset and (optionally) loan
   */
  startAddInvestment() {
    const returnPath = this.router.url;
    this.startNewSurvey('investment', [], returnPath);
  }

  /**
   * Start a dialog to add a business.
   */
  startAddBusiness() {
    const returnPath = this.router.url;
    this.startNewSurvey('business', [], returnPath);
  }

  /**
   * Start a dialog to update investment account.
   * 
   * @param id The ID of the existing property account.
   */
  startUpdateInvestment(id?: number) {
    let facts: Fact[];
    if (typeof(id) === 'undefined') {
      facts = [{ slug: 'assets_investment_edit', type: ValueType.Boolean, value: true, '@type': 'fact' }];
    } else {
      facts = [{ slug: 'assets_investment_id', type: ValueType.Long, value: id, '@type': 'fact' }];  // the property ID fact
    }
    const returnPath = this.router.url;
    this.startNewSurvey('investment', facts, returnPath);
  }


  /**
   * Start a survey to update business account details.
   * 
   * @param id 
   */
  startUpdateBusiness(id: number) {
    const facts: Fact[] = [{ slug: 'assets_business_id', type: ValueType.Long, value: id, '@type': 'fact' }];  // the property ID fact
    const returnPath = this.router.url;;
    this.startNewSurvey('business', facts, returnPath);
  }

  private startNewSurvey(survey: string, facts: Fact[], returnPath: string) {
    this.sessionId = this.dialogService.generateSessionId();

    // initialise dialog with existing facts
    this.dialogService.initDialog('track', survey, facts, this.sessionId).subscribe(result => {
      // redirect to survey path
      this.router.navigate(['survey', 'track', survey], { queryParams: { 'session': this.sessionId, 'return': returnPath, 'start': '_first' } });
    });
  }

}
